// extracted by mini-css-extract-plugin
export default {"root":"CjVFHu","bg":"jxGmPF","top":"w7cunJ","bot":"Hmyl0O"};